import React, { useEffect, useState } from 'react';
import { useAppContext } from '../context/AppContext';

export default function PixelCounter() {
  const { pixelsSold } = useAppContext();
  const [display, setDisplay] = useState(pixelsSold);

  useEffect(() => {
    const t = setInterval(() => {
      setDisplay(d => d + Math.floor(Math.random() * 30));
    }, 8000);
    return () => clearInterval(t);
  }, []);

  const pct = ((display / 1000000) * 100).toFixed(2);

  return (
    <div className="fixed bottom-6 right-4 z-30 pointer-events-none">
      <div className="px-4 py-3 rounded-xl text-right"
        style={{ background: 'rgba(8,0,18,0.95)', border: '1px solid rgba(255,0,200,0.2)', boxShadow: '0 0 20px rgba(255,0,200,0.08)' }}>
        <div className="text-gray-500 uppercase tracking-widest" style={{ fontSize: '11px' }}>Pixels claimed</div>
        <div className="font-black text-white font-mono" style={{ fontSize: '20px', letterSpacing: '-1px' }}>
          {display.toLocaleString()}
          <span className="text-gray-600 font-normal" style={{ fontSize: '13px' }}> / 1,000,000</span>
        </div>
        <div className="mt-1.5 h-1.5 rounded-full bg-gray-800 overflow-hidden w-32 ml-auto">
          <div className="h-full rounded-full"
            style={{ width: `${pct}%`, background: 'linear-gradient(90deg,#ff00cc,#cc00ff)' }} />
        </div>
        <div className="mt-0.5" style={{ color: '#ff00cc', fontSize: '13px' }}>{pct}% sold</div>
      </div>
    </div>
  );
}